import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { nav, EMAIL, GITHUB_USER, LINKEDIN_URL } from '../content/portfolio';

const Footer: React.FC = () => {
  const { language, t } = useLanguage();

  const columns = [
    {
      title: language === 'pt' ? 'Páginas' : 'Pages',
      links: nav[language].map((n) => ({ label: n.label, href: `#${n.id}`, external: false })),
    },
    {
      title: language === 'pt' ? 'Online' : 'Online',
      links: [
        { label: 'GitHub', href: `https://github.com/${GITHUB_USER}`, external: true },
        { label: 'LinkedIn', href: LINKEDIN_URL, external: true },
      ],
    },
    {
      title: language === 'pt' ? 'Contato' : 'Contact',
      links: [{ label: EMAIL, href: `mailto:${EMAIL}`, external: false }],
    },
  ];

  return (
    <footer data-ink="#e8e6e1" data-field="#0c0b09" className="bg-code-bg pb-8 pt-20 text-code-text">
      <div className="container-responsive">
        <div className="grid gap-10 sm:grid-cols-3">
          {columns.map((col) => (
            <div key={col.title}>
              <p className="text-base text-code-comment">{col.title}</p>
              <ul className="mt-3 space-y-2 text-xl">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="break-all hover:opacity-70"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <svg viewBox="0 0 1000 150" className="mt-24 w-full" role="img" aria-label="Isaac Ribeiro Leão">
          <text
            x="0"
            y="118"
            fill="currentColor"
            fontFamily="Newsreader, Georgia, serif"
            fontSize="140"
            fontWeight="500"
            textLength="1000"
            lengthAdjust="spacingAndGlyphs"
          >
            Isaac Ribeiro Leão
          </text>
        </svg>

        <p className="mt-8 text-base text-code-comment">
          Isaac Ribeiro Leão, {t('footer.role')}. © {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
